import classNames from 'classnames';

import { FormLineProps } from './FormLine.types';

const FormLine = ({ children, className, 'data-testid': dataTestId}: FormLineProps) => {
  return <div className={classNames('mb-M', className)} data-testid={`${dataTestId}-form-line`}>{children}</div>;
};

export default FormLine;
